import { render, staticRenderFns } from "./PageLoad.vue?vue&type=template&id=dc12703a&"
import script from "./PageLoad.vue?vue&type=script&lang=js&"
export * from "./PageLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports